import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
	pageBackgroundColor: '#180f28',
	cardBackgroundColor: '#7C29C5',
	hignlightBorderColor: '#7C29C5',
	cardBtnBackgroundColor: '#382a52',
	primaryBtnBackgroundColor: '#8C33DE'
}

export default {
	state,
	getters,
	actions,
	mutations
};